import { Button } from "components/Button/Button";
import { Loading } from "components/Loading/loading";
import { Toast } from "components/ToastShow/ToastAlert";
import { useEffect, useRef, useState } from "react";
import { MessageType } from "types/enum";
import { GetReportWithJsonData, trans } from "utils/helpers";
import {
  getContractConstraint,
  getDataForPrint,
  getSalesContractById,
  getSalesContractByReferenceId,
  postSalesContract,
} from "./api";

import { TabBar } from "components/Tabbar/Tabbar";
import { GuaranteeForm } from "./components/GuaranteeForm";
import { MainForm } from "./components/MainForm";
import { GUID_EMPTY } from "utils/constants";

interface SalesContractFormProps {
  onHide?: (usenavigate?) => void;
  relod: () => void;
  jobId?: any;
  processId?: any;
  referenceId?: any;
  mode: any;
  step?: any;
  SourceData?: any;
  sourceDataParam?: any;
  taskId?: any;
  Id?: any;
  rowObject?: any;
  handleShowReferenceStepper?: (referenceId: string) => void;
  buttonPrintObjCallBack?: any;
}

export const SalesContractForm = ({
  mode,
  relod,
  onHide,
  rowObject,
  handleShowReferenceStepper,
  step,
  taskId,
  jobId,
  Id,
  sourceDataParam,
  SourceData,
  processId,
  referenceId,
  buttonPrintObjCallBack,
}: SalesContractFormProps) => {
  const [resetForm, setResetForm] = useState(false);

  const [salesContractDetail, setSalesContractDetail] = useState<any>([]);

  const [response, setResponse] = useState<any>();
  const [loading, setLoading] = useState<any>(false);
  const [userChanges, setUserChanges] = useState({});

  const [selectedObj, setSelectedObj] = useState<any>(null);

  const [contractConstraint, setContractConstraint] = useState<any>({});

  const [salesContractNo, setSalesContractNo] = useState<any>(false);

  const [curentTab, setCurentTab] = useState<any>("main");
  const mainFormRef = useRef<any>();
  const guaranteeFormRef = useRef<any>();

  const [requiredFields, setRequiredFields] = useState<any>();
  let IsFiscal =
    mode == "create" ? contractConstraint.IsFiscal : response?.GrandTotalPrice;

  let content = [
    {
      title: "main",
      body: (
        <MainForm
          loading={loading}
          ref={mainFormRef}
          response={response}
          mode={mode}
          SourceData={SourceData}
          sourceDataParam={sourceDataParam}
          contractConstraint={contractConstraint}
          salesContractNo={salesContractNo}
          salesContractDetail={salesContractDetail}
          setSalesContractDetail={setSalesContractDetail}

          // sendDataForCalcAsync={sendDataForCalcAsync}
        />
      ),
    },
    {
      title: "guarantee",
      body: (
        <GuaranteeForm
          ref={guaranteeFormRef}
          response={response}
          mode={mode}
          contractConstraint={contractConstraint}
          SourceData={SourceData}
          sourceDataParam={sourceDataParam}

          // sendDataForCalcAsync={sendDataForCalcAsync}
        />
      ),
    },
  ];

  const handlesalesContractDetailFormSubmit = async () => {
    // event.preventDefault();
    // let SubTotalPrice: any = 0;
    // let newsalesContractDetail = JSON.parse(
    //   JSON.stringify(salesContractDetail)
    // ).map((e: any) => {
    //   SubTotalPrice = +e.TotalPrice + SubTotalPrice;
    //   delete e.Id;
    //   return e;
    // });
    // let data: any = {
    //   RecipientPersonDescription: person?.Name ?? null,
    //   RecipientPersonId: person?.Id ?? null,
    //   CurrencyId: !contractConstraint.IsFiscal ? undefined : currency?.Id,
    //   SalesContractNo: event.target.salesContractNo.value,
    //   SalesContractDate: salesContractDate,
    //   PriceListId: event.target.PriceList?.value,
    //   PaymentMethodId: !contractConstraint.IsFiscal
    //     ? undefined
    //     : event.target.PaymentMethodId?.value,
    //   CustomerId: customerInfo.Id,
    //   CustomerName: customer.Name,
    //   CustomerPhone: customer.SundryCustomer
    //     ? event.target?.CustomerPhone?.value
    //     : customer?.CustomerPhone?.Name.split(":")[1]
    //     ? customer?.CustomerPhone?.Name.split(":")[1]
    //     : customer?.CustomerPhone?.Name ?? null,
    //   CustomerMobilePhone: customer.SundryCustomer
    //     ? event.target?.CustomerMobilePhone?.value
    //     : customer?.CustomerMobilePhone?.Name.split(":")[1]
    //     ? customer?.CustomerMobilePhone?.Name.split(":")[1]
    //     : customer?.CustomerMobilePhone?.Name ?? null,
    //   CustomerAddress: event.target.Address?.value ?? null,
    //   CustomerEconNo: event.target.CustomerEconNo?.value,
    //   CustomerNationalCode: event.target.CustomerNationalCode?.value,
    //   DeliveryAddress: event.target.DeliveryAddress?.value,
    //   Description: event.target.Description?.value,
    //   IsCurrency: !contractConstraint.IsFiscal
    //     ? undefined
    //     : !currency.IsDefault,
    //   CurrencyRate: !contractConstraint.IsFiscal
    //     ? undefined
    //     : currency.CurrencyRate,
    //   TotalDiscount: !contractConstraint.IsFiscal
    //     ? undefined
    //     : +totalRows?.TotalDiscount,
    //   TotalPrice: !contractConstraint.IsFiscal
    //     ? undefined
    //     : +payment.totalprice,
    //   TotalTax:
    //     !contractConstraint.IsFiscal || !contractConstraint.HasTax
    //       ? 0
    //       : +totalRows?.TotalTax,
    //   GrandTotalPrice: !contractConstraint.IsFiscal
    //     ? undefined
    //     : +totalRows?.SubTotalPrice -
    //       +totalRows?.TotalDiscount +
    //       +totalRows?.TotalTax,
    //   Prepayment: !contractConstraint.IsFiscal
    //     ? undefined
    //     : +event.target.Prepayment?.value.replaceAll(",", ""),
    //   SubTotalPrice: !contractConstraint.IsFiscal
    //     ? undefined
    //     : +totalRows?.SubTotalPrice,
    //   salesContractDetailDTOList: newsalesContractDetail,
    //   IsFiscal: contractConstraint.IsFiscal,
    // };

    const guaranteeData = guaranteeFormRef.current.getAllData();
    const mainFormData = mainFormRef.current.getAllData();
    const data = {
      ...guaranteeData,
      ...mainFormData,
    };
    if (guaranteeData && mainFormData) {
      try {
        await postSalesContract(data);
       onHide && onHide()
       relod()
      } catch (error:any) {
        


  if (error.response.data.MessageType == MessageType.confirm) {       
      
     
        Toast(error.response.data.Message, MessageType.confirm, () => {
          setResponse({...error.response.data.Data});

        });
      }


        
      }
    }
  };

  // const sendDataForCalcAsync = async (newPriceList) => {
  //   setDateLoading(false);
  //   let SubTotalPrice: any = 0;
  //   let newsalesContractDetail = JSON.parse(
  //     JSON.stringify(salesContractDetail)
  //   ).map((e: any) => {
  //     SubTotalPrice = +e.TotalPrice + SubTotalPrice;

  //     return e;
  //   });

  //   let data = {
  //     RecipientPersonDescription: person?.Name ?? null,
  //     RecipientPersonId: person?.Id ?? null,
  //     CurrencyId: !contractConstraint.IsFiscal
  //       ? undefined
  //       : newPriceList?.CurrencyId,
  //     SalesContractNo: contractRef.current.salesContractNo.value,
  //     SalesContractDate: salesContractDate,
  //     PriceListId: newPriceList
  //       ? newPriceList.Id
  //       : contractRef.current?.PriceList?.value,
  //     PaymentMethodId: !contractConstraint.IsFiscal
  //       ? undefined
  //       : contractRef.current.PaymentMethodId?.value,
  //     CustomerId: customerInfo?.Id,
  //     CustomerName: customer?.Name,
  //     CustomerPhone: customer?.CustomerPhone?.Name.split(":")[1]
  //       ? customer?.CustomerPhone?.Name.split(":")[1]
  //       : customer?.CustomerPhone?.Name ?? null,
  //     CustomerMobilePhone: customer?.CustomerMobilePhone?.Name.split(":")[1]
  //       ? customer?.CustomerMobilePhone?.Name.split(":")[1]
  //       : customer?.CustomerMobilePhone?.Name ?? null,
  //     CustomerAddress: contractRef.current.Address?.value ?? null,
  //     CustomerEconNo: contractRef.current.CustomerEconNo?.value,
  //     CustomerNationalCode: contractRef.current.CustomerNationalCode?.value,
  //     DeliveryAddress: contractRef.current.DeliveryAddress?.value,
  //     Description: contractRef.current.Description?.value,
  //     IsCurrency: !contractConstraint.IsFiscal
  //       ? undefined
  //       : !currency.IsDefault,
  //     CurrencyRate: !contractConstraint.IsFiscal
  //       ? undefined
  //       : currency.CurrencyRate,
  //     TotalDiscount: !contractConstraint.IsFiscal
  //       ? undefined
  //       : +totalRows.TotalDiscount,
  //     TotalPrice: !contractConstraint.IsFiscal
  //       ? undefined
  //       : +payment.totalprice,
  //     TotalTax:
  //       !contractConstraint.IsFiscal || !contractConstraint.HasTax
  //         ? 0
  //         : +totalRows.TotalTax,
  //     GrandTotalPrice: !contractConstraint.IsFiscal
  //       ? undefined
  //       : +totalRows?.SubTotalPrice -
  //         +totalRows?.TotalDiscount +
  //         +totalRows?.TotalTax,
  //     Prepayment: !contractConstraint.IsFiscal
  //       ? undefined
  //       : +contractRef.current.Prepayment?.value.replaceAll(",", ""),
  //     SubTotalPrice: !contractConstraint.IsFiscal
  //       ? undefined
  //       : +totalRows?.SubTotalPrice,
  //     salesContractDetailDTOList: newsalesContractDetail,
  //     IsFiscal: contractConstraint.IsFiscal,
  //     Id: response?.Id,
  //     SalesContractStatusId: salesContractStatusId,
  //     JobId: jobId,
  //     JobNo: response?.JobNo,
  //   };
  //   try {
  //     if (mode !== "view" && newPriceList.Id != priceList.Id) {
  //       const res = await CalculateSalesContract(data);
  //       setSalesContractNo(res.Data?.SalesContractNo);
  //       setResponse(res.Data);
  //       setSalesContractDetail(res.Data?.salesContractDetailDTOList);
  //       let newItemCount = 0;
  //       res.Data?.salesContractDetailDTOList.map((item) => {
  //         newItemCount += item.Qty;
  //       });

  //     }
  //     setPriceList(newPriceList);
  //   } catch (error) {
  //     setPriceList(priceList);
  //   }
  //   setDateLoading(true);
  // };

  // async function getDefaultPersonContactAsync(personId) {
  //   try {
  //     const res2 = await getPersonCustomer(personId);
  //     setCustomer((pre) => {
  //       return {
  //         ...pre,
  //         Id: res2.Data.Customer.Id,
  //         Name: res2.Data.Customer.CustomerPersonDescription,
  //         SundryCustomer:
  //           res2.Data.Customer.Id == contractConstraint?.SundryCustomerId,
  //       };
  //     });
  //     if (res2.Data.Customer.Id == contractConstraint?.SundryCustomerId) {
  //       setCustomerInfo({ ...res2?.Data?.Customer });
  //     } else {
  //       if (mode != "view") {
  //         const res = await getDefaultPersonContact(
  //           res2?.Data?.Customer?.CustomerPersonId
  //         );
  //         if (res?.MessageType == MessageType.error && res2?.Data == null) {
  //         } else setCustomerInfo({ ...res.Data, ...res2?.Data?.Customer });
  //       } else setCustomerInfo({ ...res2?.Data?.Customer });
  //     }
  //   } catch (error) {}
  // }

  async function getContractConstraintAsync(withLoading = false) {
    if (withLoading) setLoading(false);
    try {
      const res = await getContractConstraint();
      setSalesContractNo(res.Data.DocNo);
      setContractConstraint(res.Data);
      setRequiredFields(res.Data.RequiredFields?JSON.parse(res.Data.RequiredFields):null);
      if (withLoading) setLoading(true);
      return res.Data;
    } catch (error) {}
    if (withLoading) setLoading(true);
  }

  async function getContractAsync() {
    setLoading(false);

    try {
      const constraint = await getContractConstraintAsync();
      let res: any;
      if (referenceId) {
        res = await getSalesContractByReferenceId(referenceId);
        // res = await getSalesOrderById(rowObject ? rowObject.Id : jobId);
      } else {
        res = await getSalesContractById(rowObject ? rowObject.Id : jobId);
      }

      if (res.Data.Id && res.Data.Id != GUID_EMPTY) {
        buttonPrintObjCallBack &&
          buttonPrintObjCallBack({
            Id: res.Data.Id,
            reportDomain: "OfficeAutomation",
            objectTag: "SalesContractForm",
            apiFunction: getDataForPrint,
          });
      }
      setSalesContractNo(res.Data.SalesContractNo);
      setResponse(res.Data);
      let count = 0;
      res.Data.SalesContractDetailDTOList.map((item) => {
        count += +item.Qty;
      });

      // setTotalRows({
      //   ItemCount: count,
      //   TotalTax: constraint.HasTax ? res.Data.TotalTax : 0,
      //   TotalDiscount: res.Data.TotalDiscount,
      //   SubTotalPrice: res.Data.SubTotalPrice,
      // });
      // setPayment({
      //   totalprice: res.Data.totalprice,
      //   Prepayment: res.Data.Prepayment,
      // });
      // setReceive({
      //   GrandTotalPrice: res.Data.GrandTotalPrice,
      //   Prepayment: res.Data.Prepayment,
      // });
    } catch (error) {}
    setLoading(true);
  }

  // const handlesetContractDetail = (newObj) => {
  //   if (contractConstraint.AllowDuplicateItems || detailMode == "edit") {
  //     setTotalRows({
  //       ItemCount:
  //         detailMode == "create"
  //           ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty)
  //           : RoundOutputOperation(
  //               totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)
  //             ),
  //       TotalTax: contractConstraint.HasTax
  //         ? detailMode == "create"
  //           ? totalRows.TotalTax + +newObj.Tax
  //           : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax)
  //         : 0,
  //       TotalDiscount:
  //         detailMode == "create"
  //           ? totalRows.TotalDiscount + +newObj.Discount
  //           : totalRows.TotalDiscount +
  //             (+newObj.Discount - +selectedObj.Discount),
  //       SubTotalPrice:
  //         detailMode == "create"
  //           ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
  //           : totalRows.SubTotalPrice +
  //             (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
  //     });
  //     if (detailMode == "create") {
  //       setSalesContractDetailHandler([...salesContractDetail, newObj]);
  //     } else {
  //       let newItemes = salesContractDetail.map((item: any) => {
  //         if (item.Id == newObj.Id) {
  //           return newObj;
  //         } else return item;
  //       });
  //       setSalesContractDetailHandler(newItemes);
  //     }
  //     // Toast("msg_saveddatasuccessfully", "success");
  //     Toast("msg_saveddatasuccessfully", MessageType.success);

  //     setDataChange(true);
  //     return true;
  //   } else {
  //     let Dupli = salesContractDetail.find(
  //       (e: any) => e.ItemId == newObj.ItemId
  //     );
  //     if (!Dupli || salesContractDetail.length == 0) {
  //       setTotalRows({
  //         ItemCount:
  //           detailMode == "create"
  //             ? RoundOutputOperation(totalRows.ItemCount + +newObj.Qty)
  //             : RoundOutputOperation(
  //                 totalRows.ItemCount + (+newObj.Qty - +selectedObj.Qty)
  //               ),
  //         TotalTax: contractConstraint.HasTax
  //           ? detailMode == "create"
  //             ? totalRows.TotalTax + +newObj.Tax
  //             : totalRows.TotalTax + (+newObj.Tax - +selectedObj.Tax)
  //           : 0,
  //         TotalDiscount:
  //           detailMode == "create"
  //             ? totalRows.TotalDiscount + +newObj.Discount
  //             : totalRows.TotalDiscount +
  //               (+newObj.Discount - +selectedObj.Discount),
  //         SubTotalPrice:
  //           detailMode == "create"
  //             ? totalRows.SubTotalPrice + +newObj.SubTotalPrice
  //             : totalRows.SubTotalPrice +
  //               (+newObj.SubTotalPrice - +selectedObj.SubTotalPrice),
  //       });
  //       if (detailMode == "create") {
  //         setSalesContractDetailHandler([...salesContractDetail, newObj]);
  //       } else {
  //         let newItemes = salesContractDetail.map((item: any) => {
  //           if (item.Id == newObj.Id) {
  //             return newObj;
  //           } else return item;
  //         });
  //         setSalesContractDetailHandler(newItemes);
  //       }
  //       // Toast("msg_saveddatasuccessfully", "success");
  //       Toast("msg_saveddatasuccessfully", MessageType.success);

  //       setDataChange(true);
  //       return true;
  //     } else {
  //       // Toast("msg_duplicateitems", "error");
  //       Toast("msg_duplicateitems", MessageType.error);

  //       return false;
  //     }
  //   }
  // };
  const selectedObjCallback = (obj, index) => {
    setSelectedObj(obj);
  };

  function cancel() {
    if (sessionStorage.getItem("changingforms") + "" == "true") {
      // Toast(trans("modalclosemessage"), "warning", "alertWithoutClose", () => {
      //   sessionStorage.setItem("changingforms", "false");
      //   setUserChanges({});
      //   onHide && onHide();
      // });
      Toast(trans("modalclosemessage"), MessageType.confirm, () => {
        sessionStorage.setItem("changingforms", "false");
        setUserChanges({});
        onHide && onHide();
      });
    } else {
      onHide && onHide();
    }
  }

  const handleBeforeUnload = (event) => {
    event.preventDefault();
    event.returnValue = "";
  };

  // const handleOpenDetailForm = () => {
  //   if (priceList || !IsFiscal) {
  //     if (customerInfo?.CustomerPersonId || customer?.SundryCustomer) {
  //       setDetailMode("create");
  //       setShowForm(true);
  //     } else {
  //       // Toast("msg_customernotselected", "error");
  //       Toast("msg_customernotselected", MessageType.error);
  //     }
  //   } else {
  //     Toast("msg_choosepricelist", MessageType.error);
  //     // Toast("msg_choosepricelist", "error");
  //   }
  // };



  useEffect(() => {
    if (Object.values(userChanges).filter((item) => item != null).length > 0) {
      sessionStorage.setItem("changingforms", "true");
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    } else {
      sessionStorage.setItem("changingforms", "false");
      window.removeEventListener("beforeunload", handleBeforeUnload);
    }
  }, [userChanges]);

  useEffect(() => {
    if (mode != "create") {
      getContractAsync();
    } else {
      getContractConstraintAsync(true);
    }
  }, []);
  useEffect(() => {
    if (resetForm) {
      setResetForm(false);
    }
  }, [resetForm]);

  // const kydown = (event) => {
  //   if (event.key == "Insert") {
  //     event.stopPropagation();
  //     event.preventDefault();
  //     handleOpenDetailForm();
  //   }
  // };
  // useEffect(() => {
  //   document.addEventListener("keydown", kydown, true);
  //   return () => {
  //     document.removeEventListener("keydown", kydown, true);
  //   };
  // }, [customer, contractConstraint, priceList]);
  const tabChangeHandle = (tab) => {
    setCurentTab(tab);
  };
  return (
    <>
      {loading ? (
        <div className=" ">
          <TabBar
            tabChange={tabChangeHandle}
            content={content}
            curentTab={curentTab}
            defaultTab={"main"}
          />

          <div className="d-flex justify-content-end mt-2">
            {mode != "view" ? (
              <div className="col-lg-12  btns_form">
                <Button
                  disabled={
                
                    !salesContractDetail.length
                  }
                  onClick={() => {
                    handlesalesContractDetailFormSubmit();
                  }}
                  value="save"
                  btnType="submit"
                />
                {/* {handleShowReferenceStepper && (step == 1 || mode == "create") && (
              <Button
                btnType="submit"
                value="SaveAndReference"
                onClick={() => setShowReferenceStepper(true)}
              />
            )} */}
                {!jobId && (
                  <Button
                    btnType="cancel"
                    value="Cancel"
                    onClick={() => {
                      cancel();
                    }}
                  />
                )}
              </div>
            ) : (
              <div className="col-lg-12 mt-1 btns_form">
                {!jobId && (
                  <Button
                    btnType="primary"
                    value="close"
                    onClick={() => {
                      cancel();
                    }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
};
